import React from 'react'
import './ProductoDetalleDescripcion.scss'
import { DobleGuion } from './DobleGuion'
import { firstCharCapitalize } from '../utils/utils'

export const ProductoDetalleDescripcion = ({ producto }) => {

    return (
        <div className="producto-detalle-descripcion">
            <div className="titulo"><p>Descripción</p> <DobleGuion /></div>
            <div className="texto">
                <p>{producto.RefSuelto} - <span className="descripcion">{producto.Descripcion}</span></p>
                <p>{producto.DescripcionLarga}</p>
            </div>
        </div >
    )
}